(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DigitalMarketing.ActOn.ActOnCampaignList",
                    {
                        url: "/CampaignList",
                        component: "actOnCampaignList",
                        PageTitle: "Act-On Campaign List | Marketing Tracker",
                        resolve: {
                            onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                                var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                                if (onBehalfOfUserId)
                                    return userApi.get(onBehalfOfUserId).catch(ng.noop);
                                return null;
                            }]
                        }
                    });
        }
    ]);

    app.component("actOnCampaignList",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/DigitalMarketing/ActOn/ActOnCampaignList/act-on-campaign-list-template.html",
            controller: actOnCampaignListController,
            bindings: {
                user: "<",
                onBehalfOfUser: "<"
            }
        });

    actOnCampaignListController.$inject = ["figToaster", "marketingTrackerActOnApi"];
    function actOnCampaignListController(figToaster, marketingTrackerActOnApi) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    loading: false,
                    reloadingData: false
                },
                pageSizes: [25, 50, 100],
                refreshData: refreshData,
                toggleSort: toggleSort
            });

        function _resetFilters(propertyName, pageSize, reverseOrder, currentPage, ccCampaignSearch) {
            $ctrl.propertyName = propertyName || 'Name';
            $ctrl.pageSize = pageSize || $ctrl.pageSizes[0];
            $ctrl.reverseOrder = reverseOrder || false;
            $ctrl.currentPage = currentPage || 1;
            $ctrl.ccCampaignSearch = ccCampaignSearch || '';
        }

        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        }
        
        function refreshData() {
            _resetFilters();
        }
        
        $ctrl.$onInit = function () {
            $ctrl.ui.loading = true;
            _resetFilters();
            marketingTrackerActOnApi.getCampaigns()
                .then(function (response) {
                    $ctrl.actOnCampaigns = _.filter(response, function (campaign) {
                        campaign.modifiedDate = new Date(campaign.modifiedTimestampEpoch * 1000);
                        campaign.assetCount = campaign.assetIds.length;
                        //limit to remove Draft email campaigns
                        return campaign.assetCount > 1;
                    });
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem retrieving your data. Please try again shortly.";
                    toastClass = "is-error";
                    figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {

            $ctrl.ui.loading = false;
                });
        };
    }

})(window.app, window.angular); //jshint ignore:line